module.exports = __webpack_public_path__ + "img/rita-robles-feranandez.c76d45a9.jpg";